module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/title/title-off-program-ec9376b0d70c3e4fb7d68c43b803cc71.svg&quot;;"